import { preferred_cps_option } from 'DataConstants';
import React, { useEffect } from 'react';

import './style.css';
import { HardSoftPreferenceForListViewPropsType } from './types';

/*
  The Hard/Soft preference is tied to the list of PCP/services it was selected for.
*/

export const HardSoftPreferenceForListView = (props: HardSoftPreferenceForListViewPropsType) => {

  const {
    value,
    visit,
    onChangeOfServices,
    designationObj,
    careProsList,
    thereAreHomePersonalCareServicesSelected,
    thereAreHomeTherapyServicesSelected,
    thereAreHomeMedicalServicesSelected,
  } = props;

  const title = value === 'hard' ? 'Hard Preference' : 'Soft Preference';

  // Identify which type of PCP the preference was selected for
  const valueIsForHomePersonalCare = designationObj?.designation === 'home_personal_care';
  const valueIsForHomeTherapy = designationObj?.designation === 'home_therapy';
  const valueIsForHomeMedical = designationObj?.designation === 'home_medical';

  // Identify if PCP list exist
  const personalCareCPs = careProsList?.home_personal_care;
  const therapyCPs = careProsList?.home_therapy;
  const medicalCPs = careProsList?.home_medical;

  const thereArePersonalCareCPs = personalCareCPs && personalCareCPs.length > 0;
  const thereAreTherapyCPs = therapyCPs && therapyCPs.length > 0;
  const thereAreMedicalCPs = medicalCPs && medicalCPs.length > 0;

  let displayPreference = false;

  if (thereAreHomePersonalCareServicesSelected && thereArePersonalCareCPs && valueIsForHomePersonalCare) {
    displayPreference = true;
  };

  if (thereAreHomeTherapyServicesSelected && thereAreTherapyCPs && valueIsForHomeTherapy) {
    displayPreference = true;
  };

  if (thereAreHomeMedicalServicesSelected && thereAreMedicalCPs && valueIsForHomeMedical) {
    displayPreference = true;
  };

  const onChangeToServicesSelected = () => {
    /*
      This special function runs on changes to the services selected in the list view.
      If certain services are removed, preference must be updated to match (happens here).
      Supports both individual visit modification and applying to all visits (since this runs on each visit's services changes).
    */

    // HPC but either no services or no PCP list
    if (valueIsForHomePersonalCare && (!thereAreHomePersonalCareServicesSelected || !thereArePersonalCareCPs)) {
      delete visit[preferred_cps_option];
      onChangeOfServices(visit);
      return;
    };

    // Home Therapy but either no services or no PCP list
    if (valueIsForHomeTherapy && (!thereAreHomeTherapyServicesSelected || !thereAreTherapyCPs)) {
      delete visit[preferred_cps_option];
      onChangeOfServices(visit);
      return;
    };

    // Home Medical but either no services or no PCP list
    if (valueIsForHomeMedical && (!thereAreHomeMedicalServicesSelected || !valueIsForHomeMedical)) {
      delete visit[preferred_cps_option];
      onChangeOfServices(visit);
      return;
    };

    if (designationObj && thereAreHomePersonalCareServicesSelected && thereArePersonalCareCPs && valueIsForHomePersonalCare) {
      // restore pref for HPC if switched back to HPC
      visit[preferred_cps_option] = designationObj.preference;
      onChangeOfServices(visit);
      return;
    };

    if (designationObj && thereAreHomeTherapyServicesSelected && thereAreTherapyCPs && valueIsForHomeTherapy) {
      // restore pref for HPC if switched back to HPC
      visit[preferred_cps_option] = designationObj.preference;
      onChangeOfServices(visit);
      return;
    };

    if (designationObj && thereAreHomeMedicalServicesSelected && thereAreMedicalCPs && valueIsForHomeMedical) {
      // restore pref for HPC if switched back to HPC
      visit[preferred_cps_option] = designationObj.preference;
      onChangeOfServices(visit);
      return;
    };
  };

  useEffect(() => {
    onChangeToServicesSelected();
  }, [thereAreHomePersonalCareServicesSelected, thereAreHomeTherapyServicesSelected, thereAreHomeMedicalServicesSelected]);

  if (!value || value === 'none') {
    return null;
  };

  if (!displayPreference) {
    return null
  };

  return <span className='radio-field-title list-view-title'>{title}</span>;

};